/* Chroma · global behaviour: reveal-on-scroll, header shrink, mobile nav, FAQ */
(function () {
  'use strict';

  /* reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* header shrink on scroll */
  function initHeader() {
    var hdr = document.querySelector('.chroma-header');
    if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('shrunk', window.scrollY > 40); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* mobile nav toggle */
  function initNav() {
    var burger = document.querySelector('.burger');
    var links = document.getElementById('chroma-navlinks');
    if (!burger || !links) return;
    burger.addEventListener('click', function () {
      var open = links.classList.toggle('mobopen');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    links.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        links.classList.remove('mobopen');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* FAQ accordion */
  function initFaq() {
    document.querySelectorAll('.qa').forEach(function (qa) {
      var btn = qa.querySelector('button');
      var ans = qa.querySelector('.ans');
      if (!btn || !ans) return;
      btn.addEventListener('click', function () {
        var open = qa.classList.toggle('open');
        ans.style.maxHeight = open ? ans.scrollHeight + 'px' : 0;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function init() { initReveal(); initHeader(); initNav(); initFaq(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
